import { render, staticRenderFns } from "./OtherFacilitiesApplicationTable.vue?vue&type=template&id=7036075c&lang=pug"
import script from "./OtherFacilitiesApplicationTable.vue?vue&type=script&lang=ts"
export * from "./OtherFacilitiesApplicationTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports